import { render } from "./Button.vue?vue&type=template&id=773d50ca&scoped=true&ts=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=773d50ca&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773d50ca"]])

export default __exports__